import { render, staticRenderFns } from "./saveKeywords.vue?vue&type=template&id=c5c41ad8&scoped=true&"
import script from "./saveKeywords.vue?vue&type=script&lang=js&"
export * from "./saveKeywords.vue?vue&type=script&lang=js&"
import style0 from "./saveKeywords.vue?vue&type=style&index=0&id=c5c41ad8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c41ad8",
  null
  
)

export default component.exports